import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import store from './store';

import { Router, Route, Switch } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import Srp from './components/search/search';
import Checkout from './components/checkout/checkout';
import Success from './components/success/success';

import './normalize.css';
import './index.css';

const browserHistory = createBrowserHistory()

ReactDOM.render(
    <Provider store = { store } >
        <Router history = { browserHistory } >
            <Switch>
                <Route path = "/search/" component = { Srp } />
                <Route path = "/co/exp/:token" component = { Checkout } />
                <Route path = "/success/:token" component = { Success } />
            </Switch>
        </Router>
    </Provider>,
	document.getElementById('root')
);

// registerServiceWorker();

// images
// min height
// routing